import React from "react";
import { useNavigate } from "react-router-dom";
import AppLogo from "./AppLogo";

const LoginLayout = ({ children }) => {
  const navigate = useNavigate();
  const onClickLogo = () => {
    navigate("/");
  };
  return (
    <div className="relative">
      <div className="bg-black h-screen w-screen">
        <div className="absolute h-fit w-full sm:block hidden bg-black mb-20 overflow-hidden z-10">
          <div className="px-7 py-3 flex gap-3 items-center h-14 w-full">
            <button
              type="button"
              className="h-9 pr-1 flex gap-3 items-center cursor-pointer"
              onClick={onClickLogo}
            >
              <img
                src="GamberaDynamicsLogo.svg"
                className="w-24 lg:w-28"
                alt="gd-rms_logo"
              />
              {/* <img src="Nav_logo.png" alt="LOGO" className="h-9" /> */}
              <div className="text-white font-semibold text-xl">
                | VISION AI: INTELLIGENT VIDEO SOLUTION
              </div>
            </button>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default LoginLayout;
